import { LayerType } from '../api/layers';
import { FileExtension, FileFormat } from '../enums';

export const fileFormatByExtension = {
  [FileExtension.MBTiles]: FileFormat.MBTiles,
  [FileExtension.GeoTIFF]: FileFormat.GeoTIFF,
  [FileExtension.TIFF]: FileFormat.GeoTIFF,
  [FileExtension.GPKG]: FileFormat.GPKG,
  [FileExtension.DXF]: FileFormat.DXF,
  [FileExtension.LAZ]: FileFormat.LAZ,
  [FileExtension.LAS]: FileFormat.LAS,
  [FileExtension.CSV]: FileFormat.CSV,
};

export const fileExtensionByLayerType = {
  [LayerType.Vector]: [FileExtension.ZIP],
  [LayerType.MBTiles]: [FileExtension.MBTiles],
  [LayerType.CapturedDsm]: [FileExtension.GeoTIFF, FileExtension.TIFF],
  [LayerType.Orthomosaic]: [FileExtension.GeoTIFF, FileExtension.TIFF],
  [LayerType.KML]: [FileExtension.KML, FileExtension.KMZ],
  [LayerType.PointCloud]: [
    FileExtension.LAS,
    FileExtension.LAZ,
    FileExtension.CSV,
  ],
  [LayerType.Cad]: [FileExtension.DXF],
};

export const displayNameByFileExtension: Record<FileExtension, string> = {
  [FileExtension.MBTiles]: 'MBTiles',
  [FileExtension.GeoTIFF]: 'GeoTIFF',
  [FileExtension.TIFF]: 'GeoTIFF',
  [FileExtension.GPKG]: 'GPKG',
  [FileExtension.DXF]: 'DXF',
  [FileExtension.LAZ]: 'LAZ',
  [FileExtension.LAS]: 'LAS',
  [FileExtension.CSV]: 'CSV',
  [FileExtension.ZIP]: 'ZIP',
  [FileExtension.KML]: 'KML',
  [FileExtension.KMZ]: 'KMZ',
};
